export class EnumHelpers {
    // @todo upgrade ts-lint lib to es8 and replace it with Object.values
    public static getValues(e: any): string[] {
        return Object.keys(e).map((k: any) => e[k]);
    }

    public static getValueIndex(e: any, v: any): number {
        return EnumHelpers.getValues(e).indexOf(v);
    }
}
